import { render, staticRenderFns } from "./VideoEmbedded.vue?vue&type=template&id=f8b0e27a&"
import script from "./VideoEmbedded.vue?vue&type=script&lang=js&"
export * from "./VideoEmbedded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {YoutubePlayer: require('/vercel/path0/components/general/YoutubePlayer.vue').default,VimeoVideoPlayer: require('/vercel/path0/components/general/VimeoVideoPlayer.vue').default,Container: require('/vercel/path0/components/general/Container.vue').default,SelectableBgColor: require('/vercel/path0/components/general/SelectableBgColor.vue').default})
